var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "li",
    { staticClass: "last-orders__item" },
    [
      _c("span", {
        staticClass: "last-orders__item-date",
        domProps: { innerHTML: _vm._s(_vm.displayDate) }
      }),
      _vm._v(" "),
      _c("span", {
        staticClass: "last-orders__item-total",
        domProps: {
          innerHTML: _vm._s(_vm.$options.filters.fwgpricecent(_vm.order.total))
        }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "last-orders__item-items" }, [
        _c("span", {
          staticClass: "last-orders__item-items-text",
          class: {
            "last-orders__item-items-text--open": _vm.showMore
          },
          domProps: { innerHTML: _vm._s(_vm.items) }
        }),
        _vm._v(" "),
        _vm.exceedsThreshold
          ? _c("a", {
              staticClass: "last-orders__item-items-more",
              domProps: { innerHTML: _vm._s(_vm.showMoreText) },
              on: { click: _vm.onShowMore }
            })
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("ul", { staticClass: "last-orders__item-icons" }, [
        _c(
          "li",
          { staticClass: "last-orders__item-icon" },
          [
            _c(_vm.iconComponent(_vm.order.shipmentCode), {
              tag: "component",
              staticClass: "last-orders__item-icon-icon"
            }),
            _vm._v(" "),
            _c("span", {
              staticClass: "last-orders__item-icon-text",
              domProps: {
                innerHTML: _vm._s(_vm.shipmentName(_vm.order.shipmentCode))
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "li",
          { staticClass: "last-orders__item-icon" },
          [
            _c("SVGLocation", { staticClass: "last-orders__item-icon-icon" }),
            _vm._v(" "),
            _c("span", {
              staticClass: "last-orders__item-icon-text",
              domProps: { innerHTML: _vm._s(_vm.order.channelName) }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("Button", {
        staticClass: "last-orders__item-button",
        attrs: {
          level: "secondary",
          text: _vm.$t("shoplist.lastOrders.reorderButton"),
          type: "button",
          small: ""
        },
        on: {
          click: function($event) {
            $event.preventDefault()
            return _vm.$emit("click", _vm.order.tokenValiue)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }